module.exports = __webpack_public_path__ + "img/message.d6d477d8.png";